<template>
  <v-row style="border: 1px solid gray; margin-bottom: 30px">
    <v-col cols="12">
      <div>
        <h1>Populate Identity Numbers From Testator IDs</h1>
        <h3>Upload list of testator ids to retrieve the identity numbers.</h3>
        <p>Only XLSX documents allowed</p>
        <p>
          Don't upload more than 5000 rows at a time. 5000 rows takes
          approximately 13 minutes to process.
        </p>
        <div class="pb-6">
          <a
            href="/example_files/populate_identity_numbers_example.xlsx"
            download="populate_identity_numbers_example.xlsx"
            >View example of file to upload</a
          >
        </div>
        <v-file-input
          v-model="file"
          single-line
          outlined
          dense
          filled
          :loading="buttonLoading"
          label="Upload file"
          class="file-upload-btn"
        />
      </div>
      <v-btn
        rounded
        depressed
        :loading="buttonLoading"
        color="primary"
        @click="uploadFile()"
        ><span>Upload</span></v-btn
      >
    </v-col>
    <v-col cols="12" v-if="dailyTaskDownload">
      <a style="cursor: pointer" :href="dailyTaskDownload.presignedUrl">
        {{ dailyTaskDownload.fileName }}
      </a>
    </v-col>
  </v-row>
</template>

<script>
  import {
    FETCH_DAILY_TASK_DOWNLOAD_MUTATION,
    PROCESS_EXCEL_FILE_MUTATION,
  } from '../../constants/graphql/daily-tasks';
  export default {
    name: 'PopulateIdentityNumbers',
    data() {
      return {
        file: null,
        buttonLoading: false,
        intervalId: null,
        dailyTaskDownload: null,
      };
    },
    created() {
      this.intervalId = setInterval(this.fetchDailyTaskDownloadStatus, 5000);
    },
    methods: {
      uploadFile() {
        if (this.file) {
          this.buttonLoading = true;
          var reader = new FileReader();
          reader.readAsDataURL(this.file);
          reader.onload = function (evt) {
            const fileBase64 = evt.target.result;
            this.uploadFileToServer(fileBase64);
          }.bind(this);
        }
      },
      uploadFileToServer(fileBase64) {
        const testatorId = this.$store.getters.testatorId;
        const action = 'PopulateIdentityNumbersForTestators';
        this.$apollo
          .mutate({
            mutation: PROCESS_EXCEL_FILE_MUTATION,
            variables: {
              testatorId,
              fileBase64,
              action,
            },
          })
          .then(_response => {
            this.dailyTaskDownload = null;
            if (_response.data.processExcelFile.id) {
            } else {
              console.log(`An error occured`);
            }

            this.buttonLoading = false;
            this.file = null;
          })
          .catch(error => {
            this.buttonLoading = false;
            this.file = null;
          });
      },
      fetchDailyTaskDownloadStatus() {
        const testatorId = this.$store.getters.testatorId;
        const action = 'PopulateIdentityNumbersForTestators';
        this.$apollo
          .mutate({
            mutation: FETCH_DAILY_TASK_DOWNLOAD_MUTATION,
            variables: {
              testatorId,
              action,
            },
          })
          .then(_response => {
            this.dailyTaskDownload = _response.data.fetchDailyTaskDownload;
          })
          .catch(error => {
            console.log(error);
          });
      },
    },
    beforeDestroy() {
      clearInterval(this.intervalId);
    },
  };
</script>
